/** Une clases: solo conserva cadenas no vacías, ignora el resto (false, null, ReactNode…). */
export function cx(...parts: unknown[]): string {
  return parts.filter((p): p is string => typeof p === 'string' && p.length > 0).join(' ')
}
